<template>
  <v-card class="elevation-12">
    <v-toolbar color="primary" dark flat dense>
      <v-toolbar-title>Sign In</v-toolbar-title>
      <!-- <template v-slot:actions>
        <v-btn text color="blue darken-2" exact @click="$router.go(-1)">
          <v-icon left>arrow_back</v-icon>Back
        </v-btn>
      </template>-->
      <v-spacer />
      <v-btn text exact :to="{ name: 'Welcome' }" v-if="showBtn">
        <v-icon left>arrow_back</v-icon>Back
      </v-btn>
    </v-toolbar>
    <div class="py-0">
      <v-img :src="logo" class="my-3" contain height="140" />
    </div>

    <v-form ref="SignInForm" @submit.prevent>
      <v-row v-if="error">
        <v-card-title>
          <v-icon left color="error" class="mr-2 ml-2">error_outline</v-icon>
          <span class="error--text ml-2">Sign In Falied</span>
        </v-card-title>
        <v-card-text class="ml-3 error--text">{{ errorMessage }}</v-card-text>
      </v-row>
      <v-card-text class="py-0">
        <v-text-field
          outlined
          label="Email address"
          name="email"
          prepend-inner-icon="mdi-email"
          type="email"
          v-model="email"
          :rules="emailRules"
        />
        <span
          v-on:click="capsLockStateClick"
          v-on:keydown="capsLockState"
          v-click-outside="hideCapsWarning"
        >
          <v-text-field
            outlined
            id="password"
            label="Password"
            name="password"
            prepend-inner-icon="lock"
            type="password"
            v-model="password"
            :rules="passwordRules"
          />
        </span>

        <div id="capsLock" v-show="caps">
          <span
            ><v-icon small id="alertIcon" color="warning"> mdi-alert</v-icon>
            Warning: Caps Lock On</span
          >
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="secondary"
          :to="{ name: 'Registration' }"
          v-if="userRegisterEnabled"
          >Register Here</v-btn
        >
        <v-spacer />
        <v-btn
          large
          type="submit"
          :loading="signInLoading"
          color="blue darken-2"
          @click="submit"
          outlined
        >
          Sign In
        </v-btn>
      </v-card-actions>
      <!-- <v-card-actions> -->
      <v-btn
        text
        color="secondary"
        :to="{ name: 'BusinessRegistration' }"
        v-if="businessRegisterEnabled"
        >Business Signup
      </v-btn>
      <!-- </v-card-actions> -->
    </v-form>
    <div class="mt-2 py-2 dialogActions">
      <v-btn text color="secondary" :to="{ name: 'PasswordReset' }"
        >Forgot your password?</v-btn
      >
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SignInForm",
  data() {
    return {
      loading: true,
      transition: "scale-transition",
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      password: "",
      caps: null,
      passwordRules: [(v) => !!v || "Password is required"],
      showSignupMessage: false,
      error: false,
      errorMessage: "",
      signInLoading: false,
    };
  },

  computed: {
    ...mapGetters([
      "isCashUserRegistrationEnabled",
      "retrieveAllConfigs",
      "isBusinessRegistrationEnabled",
    ]),
    logo() {
      return require(process.env.VUE_APP_LOGO_MAIN);
    },

    userRegisterEnabled() {
      return this.isCashUserRegistrationEnabled;
    },

    businessRegisterEnabled() {
      return this.isBusinessRegistrationEnabled;
    },

    showMenu: {
      get: function () {
        return ["SignIn"].indexOf(this.$route.name) == -1;
      },
      // setter
      set: function (newValue) {
        this.showMenu = newValue;
      },
    },

    showBtn() {
      if (process.env.VUE_APP_NO_WELCOME_PAGE == "true") {
        return false;
      }
      return true;
    },
  },

  methods: {
    ...mapActions(["authUser", "setGuestUser", "setSnackbar"]),

    getGetter() {
      return this.isCashUserRegistrationEnabled;
    },

    capsLockStateClick: function (event) {
      this.caps = event.getModifierState("CapsLock");
    },

    //The caps lock remains stuck on true if we call getModifierState
    //on text input keypress
    capsLockState: function (event) {
      if (event.key == "CapsLock") {
        this.caps = !this.caps;
      }
    },

    hideCapsWarning: function () {
      this.caps = false;
    },

    submit() {
      if (this.$refs.SignInForm.validate() && !this.signInLoading) {
        let payload = {
          identity: "nws9987",
          email_addr: this.email,
          password: this.password,
        };
        this.error = false;
        this.errorMessage = "";

        this.signInLoading = true;

        this.authUser(payload)
          .then((response) => {
            console.log(response);
            if (response.success) {
              this.setGuestUser(false);
              this.$router.push({ name: "Home" });
            } else {
              console.log("-- Auth Error");
              this.error = true;

              if (response.message) {
                this.errorMessage = response.message;
              } else {
                this.errorMessage = "Incorrect Username or Password";
              }
            }

            this.signInLoading = false;
          })
          .catch((e) => {
            console.log(e);

            this.signInLoading = false;
          });
      }
    },
  },
  created() {
    this.$root.$on("singup-success", (signupEmail) => {
      this.email = signupEmail;
    });
  },
};
</script>

<style scoped>
#capsLock {
  width: 270px;
  font: small-caption;
  font-size: 16px;
  color: #fb8c00;
  margin-top: -5px;
}

/*So it stays perfectly aligned with the W letter*/
#alertIcon {
  margin-top: -3px;
}
</style>
